import api from "../utils/axiosInstance.js";

const getBankListRequest = () => ({ type: 'GET_BANK_LIST_REQUEST' });
const getBankListSuccess = (data) => ({ type: 'GET_BANK_LIST', payload: data });
const getBankListError = (error) => ({ type: 'GET_BANK_LIST_ERROR', payload: error });

export const getUserBankList = (data) => async (dispatch) => {
    dispatch(getBankListRequest());
    try {


        const response = await api.post(`/user/bank/list`, data);

        if (response.data.success) {
            dispatch(getBankListSuccess(response.data?.data));

        }
        else {
            dispatch(getBankListError(response?.data?.message));
        }



    } catch (error) {
        dispatch(getBankListError(error.response?.data?.message || error.message));
    }
};

export const updateUserBankListData = (newData) => ({
    type: 'UPDATE_BANK_LIST_DATA',
    payload: newData,
});

export const removeUserBankListData = (newData) => ({
    type: 'REMOVE_BANK_LIST_DATA',
    payload: newData,
});

export const selectedUserBankList = (newData) => ({
    type: 'SET_SELECTED_BANK_LIST',
    payload: newData,
});

